import { FC } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import Button from '../../../../../components/button/index';
import { CloseModalButton } from '../../../../../components/close-modal-button/index';
import { ModalWrapper } from '../../../../../components/modal-wrapper/index';
import { SignaturePopupType } from '../../enums/signature-popup-type.const';
import { useSendSignatureReminder } from '../../hooks/use-send-signature-reminder.hook';
import { SignaturePopupStore } from '../../store/signature-popup.store';

export const SignatureSendReminderModal: FC = () => {
  const isOpen = SignaturePopupStore(({ open }) => open);
  const type = SignaturePopupStore(({ type }) => type);
  const metadata = SignaturePopupStore(({ metadata }) => metadata);
  const handleDismiss = SignaturePopupStore(({ handleDismiss }) => handleDismiss);
  const { isPending, sendSignatureReminder } = useSendSignatureReminder();

  if (type !== SignaturePopupType.SEND_REMINDER || !metadata || !('signatureId' in metadata)) {
    return null;
  }

  const { signatureId } = metadata;

  const handleConfirm = async () => {
    try {
      await sendSignatureReminder(signatureId);
      handleDismiss();
    } catch {
      // Error toast handled by ApiService / mutation layer.
    }
  };

  return (
    <ModalWrapper
      className="centered flex h-screen w-screen p-2"
      control={{
        modal: true,
        onOpenChange: (open) => !open && handleDismiss(),
        open: isOpen,
      }}
      onBgClick={handleDismiss}
      side="CENTER"
    >
      <div className="flex w-full max-w-[485px] flex-col gap-6 rounded-lg bg-white p-6">
        <div className="flex items-start justify-between gap-4">
          <h2 className="text-xl font-[550] text-gray-700">
            <AppFormattedMessage id="SEND_SIGNATURE_REMINDER_CONFIRM_TITLE" />
          </h2>
          <CloseModalButton onClose={handleDismiss} />
        </div>

        <p className="text-sm text-gray-700">
          <AppFormattedMessage id="SEND_SIGNATURE_REMINDER_CONFIRM_MESSAGE" />
        </p>

        <div className="flex justify-end gap-3">
          <Button
            className="h-11 w-fit rounded border border-gray-300 px-6 text-sm font-[450] text-gray-700"
            disabled={isPending}
            onClick={handleDismiss}
            styleType="NONE"
            type="button"
          >
            <AppFormattedMessage id="NO" />
          </Button>
          <Button
            className="h-11 w-fit px-6 text-sm font-[550]"
            disabled={isPending}
            isLoading={isPending}
            onClick={() => void handleConfirm()}
            styleType="BLUE_ROUNDED"
            type="button"
          >
            <AppFormattedMessage id="YES_SEND" />
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};
